import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import '../purchaseOrder.css';
import { FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { customStyles } from '../../../../Components/helper';

const optionArray = [
  { _id: 1, name: 'Approved' },
  { _id: 2, name: 'Rejected' },
  { _id: 3, name: 'Not Applicable' },
];

function EditDocumentDetails({ onOpen, toggle, data, handleSubmit, loading, showErr }) {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    status: null,
    isVisibleToSupplier: false,
    notes: '',
    docName: '',
  });

  const {
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reduxState) => reduxState);

  const onStatusChange = (e) => {
    setState((stated) => ({
      ...stated,
      status: e,
    }));
  };

  const setVisiblity = (e) => {
    setState((stated) => ({
      ...stated,
      isVisibleToSupplier: e.target.checked,
    }));
  };

  useEffect(() => {
    setState((effectSattus) => ({
      ...effectSattus,
      docName: data?.fileName,
      isVisibleToSupplier: data?.isVisibleToSupplier,
      notes: data?.notes,
      status: setStatus(),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const setStatus = () => {
    const statuses = optionArray.filter((ele) => ele.name === data?.status);
    return statuses[0];
  };

  const inputChange = (e) => {
    if (e?.target?.name === 'docName') {
      setState((previousNames) => ({
        ...previousNames,
        docName: e.target.value,
      }));
    } else {
      setState((previousNotes) => ({
        ...previousNotes,
        notes: e.target.value,
      }));
    }
  };

  return (
    <Modal show={onOpen} backdrop="static" className="custom-modal modal-medium" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            <span>{t('FILTER.EDIT_DOCUMENT')}</span>
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        {loading && <Loader />}
        {!loading && (
          <div className="modal-buttons mt-5 justify-content-between">
            <div className="product-costing-filter">
              <FormGroup className="mb-2 ">
                <div className="custom-react-select ">
                  <label className="select-label">{t('FILTER.DOCUMENT_NAME')}</label>
                  <input name="docName" value={state.docName} onChange={inputChange} />
                </div>
                {showErr && <small className="error-message">{t('TAKING_DATES.PLEASE_ENTER_DOCUMENT_TITLE')}</small>}
              </FormGroup>
              <FormGroup className="mb-2 ">
                <div className="custom-react-select ">
                  <label className="select-label">{t('FILTER.NOTES')}</label>
                  <input name="notes" value={state.notes} onChange={inputChange} />
                </div>
              </FormGroup>
              <FormGroup className="mb-2 ">
                <div className="custom-react-select ">
                  <label className="select-label">{t('COSTING_TO_DO_LIST.STATUSS')}</label>
                  <Select
                    options={optionArray}
                    maxMenuHeight={132}
                    menuPlacement="bottom"
                    menuPosition="relative"
                    getOptionLabel={(e) => `${e?.name}`}
                    getOptionValue={(e) => `${e?._id}`}
                    onChange={(e) => onStatusChange(e)}
                    styles={customStyles}
                    value={state.status}
                    placeholder={t('PROGRESS_INDICATOR.SELECT_STATUS')}
                  />
                </div>
              </FormGroup>
              {!isSupplierLoggedIn && (
                <div className="checkbox-label">
                  <input type="checkbox" id="visibletoSupp" name="visibletoSupp" onChange={setVisiblity} checked={state.isVisibleToSupplier} />
                  <label htmlFor="visibletoSupp" className="chklabel align-items-start">
                    <p className="px-1">{t('FILTER.VISIBLE_TO_SUPPLIER')}</p>
                  </label>
                </div>
              )}
            </div>
            <div className="modal-buttons mt-3 d-flex justify-content-between">
              <button type="button" onClick={toggle} className="btn btn-default">
                {t('SPEC_TEMP_LIBRARY.CANCEL')}
              </button>
              <button type="button" className="btn btn-default" onClick={() => handleSubmit(state)}>
                {t('SETUP_2FA.SUBMIT')}
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default EditDocumentDetails;
